export const contactLensScheduleColumns = [
    // {
    //     Header: 'ID',
    //     accessor: 'id',
    //     disableFilters: true,
    //     disableSortBy: true,
    //     width: 50,
    // },
    {
        Header: 'Schedule Name',
        accessor: 'name',
        width: 200,
    },
    {
        Header: 'Days Supply',
        accessor: 'daysSupply',
        width: 120,
        Cell: ({ value }) => value ? `${value} days` : '-',
    },
    // {
    //     Header: 'Notes',
    //     accessor: 'notes',
    //     width: 300,
    //     Cell: ({ value }) => value ? (
    //         <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
    //             {value}
    //         </span>
    //     ) : '-',
    // },
];
